import React from 'react';

export default props => (
  <svg viewBox={props.viewBox || '0 0 25 25'} style={{ display: 'block', margin: '0 auto' }}>
    <g fill={props.color}>
      <path d="M24.6,5.4c0.5-0.5,0.5-1.4,0-1.9l-3.1-3.1c-0.5-0.5-1.4-0.5-1.9,0L17,3l5,5L24.6,5.4z M21,9.7L15.3,4L0,19.3V25h5.7L21,9.7z" />
    </g>
  </svg>
);
